/**
 * THIS FILE IS GENERATED AUTOMATICALLY.
 * DO NOT EDIT.
 *
 * You are probably looking on adding startup/initialization code.
 * Use "quasar new boot <name>" and add it there.
 * One boot file per concern. Then reference the file(s) in quasar.config.js > boot:
 * boot: ['file', ...] // do not add ".js" extension to it.
 *
 * Boot files are your "main.js"
 **/



import {Loading,Notify,Dialog,LoadingBar,Meta,BottomSheet} from 'quasar'



export default { config: {"dark":false,"loadingBar":{"color":"red-3","size":"2px"},"capacitor":{"iosStatusBarPadding":true}},plugins: {Loading,Notify,Dialog,LoadingBar,Meta,BottomSheet} }

